import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import { DropdownList, Multiselect } from 'react-widgets';
import {
  convertPascalCaseToWords,
  Entity,
  LeadStageField,
} from '../../../../core';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: Entity) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: Entity[];
  error?: string;
  event?: string;
  stages?: LeadStageField[];
}> = (props) => {
  const { control, handleSubmit, errors, watch, setValue } = useForm<Entity>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const [formModal, setFormModal] = useState<{
    isOpen?: boolean;
    entity?: string;
    isEdit?: boolean;
  }>({});

  React.useEffect(() => {
    const defaultValue = props.data?.find(
      (x) => x.key === (formModal?.entity || 'Customer')
    )?.fields;

    setValue('fields', defaultValue);
    setValue('key', formModal?.entity);
  }, [formModal?.entity]);

  const renderFields = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Select Fields</label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                // rules={{
                //   required: true,
                //   validate: (value) => {
                //     return !!(value.length > 0);
                //   },
                // }}
                name="fields"
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={props.stages?.filter(
                      (x) =>
                        x.type ===
                        (formModal?.entity || 'Customer')?.toLowerCase()
                    )}
                    defaultValue={value}
                    textField={'displayName'}
                    valueField={'value'}
                    placeholder={'Select Fields'}
                    onChange={(val) => {
                      onChange(val?.map((x) => x));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.fields && <ErrorMessage>Fields is required</ErrorMessage>}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderEntity = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Select Entity</label>
          <Controller
            control={control}
            name="key"
            defaultValue={formModal?.entity}
            render={({ onChange, value, name }) => (
              <DropdownList
                data={[
                  {
                    label: 'Customer',
                    value: 'Customer',
                  },
                  {
                    label: 'Lead',
                    value: 'Lead',
                  },
                ]}
                id="key"
                placeholder="Key"
                name={name}
                value={value}
                onChange={(val) => {
                  onChange(val.value);
                  setFormModal({ isOpen: true, entity: val.value });
                }}
                textField="label"
                valueField="value"
                disabled={formModal?.isEdit}
              />
            )}
          />
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={() => setFormModal({})}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Save
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-1 font-weight-semibold">
          {convertPascalCaseToWords(props.event)}
          {(props?.data?.length || 0) < 2 && (
            <button
              type="button"
              className="btn btn-primary py-2 font-weight-semibold font-normal px-4 float-md-right"
              onClick={() => setFormModal({ isOpen: true, entity: 'Customer' })}
            >
              + Add Field
            </button>
          )}

          <p className="font-sm text-muted font-weight-lighter mt-2">
            Must to have field for {props.event}
          </p>
        </h4>
        {formModal?.isOpen && (
          <div className="row gutter-10">
            {renderEntity()}
            {renderFields()}
            <ErrorMessage>{props.error}</ErrorMessage>
            {renderButton()}
          </div>
        )}

        {!!props?.data?.length && (
          <div className="row gutter-10">
            <div className="table-responsive table-payment">
              <table className="table table-bordered font-sm text-gray-800 w-100">
                <thead>
                  <tr>
                    <th scope="col">Entity</th>
                    <th scope="col">Field</th>
                  </tr>
                </thead>
                <tbody>
                  {props?.data.map((option, index) => {
                    return (
                      <tr>
                        <td scope="col">{option.key}</td>
                        <td scope="col">
                          {option?.fields?.map((x) => x.displayName)?.join()}
                          <i
                            onClick={() =>
                              setFormModal({
                                isOpen: true,
                                entity: option.key,
                                isEdit: true,
                              })
                            }
                            className="align-items-center contact-edit cursor-pointer float-right icon-edit justify-content-center"
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default UpdateForm;
